module.exports = __webpack_public_path__ + "static/media/mercedes-8.ffff40d3.jpg";